import script from "./BmsBoardListEntry.vue?vue&type=script&setup=true&lang=ts"
export * from "./BmsBoardListEntry.vue?vue&type=script&setup=true&lang=ts"

import "./BmsBoardListEntry.vue?vue&type=style&index=0&id=08813e73&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/wdw-vue build and deploy Teledata PROD/wdw-vue-widgets/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08813e73"]])

export default __exports__